import JSONstringifyWithoutNulls from "./JSONstringifyWithoutNulls";
export default class Pagination extends JSONstringifyWithoutNulls {
    constructor() {
        super(...arguments);
        this.Take = null;
        this.Skip = null;
    }
}
